<template>
  <div class='container'>
    <h1>Social</h1>
    <p>Some of my followers.</p>

    <div class='col-container'>
      <div class='row-container'>
        <statCard
          :followers='github.data'
          :loading='github.loading'
          icon='github.png'
          link='https://github.com/MoshiCoCo'
          statTitle='GitHub'
          suffix='followers'
        />
        <statCard
          :followers='bilibili.data'
          :loading='bilibili.loading'
          icon='bilibili.png'
          link='https://space.bilibili.com/14602398'
          statTitle='BiliBili'
          suffix='followers'
        />

      </div>

      <div class='row-container'>
        <statCard
          :followers='jike.data'
          :loading='jike.loading'
          icon='jike.png'
          link='https://m.okjike.com/users/2835517f-265f-4934-b502-e1023ffc70ad'
          statTitle='Jike'
          suffix='followers'
        />
        <statCard
          :followers='steam.data'
          :loading='jike.loading'
          icon='steam.png'
          link='https://steamcommunity.com/profiles/76561198402634316/'
          statTitle='Steam'
          suffix='followers'
        />
      </div>

    </div>

    <p id='substats-footer'>
      * Follower statistics powered by:
      <a href='https://api.spencerwoo.com/substats'>Substats</a>.
    </p>
  </div>
</template>

<script>
import statCard from '@/components/StatCard.vue'

export default {
  components: {
    statCard,
  },
  data() {
    return {
      github: { data: 0, loading: true },
      telegram: { data: 0, loading: true },
      bilibili: { data: 0, loading: true },
      jike: { data: 0, loading: true },
      steam: { data: 0, loading: true },
    }
  },
  mounted() {
    const apiUrl = 'https://api.spencerwoo.com/substats'

    const githubAxios = this.axios.get(`${apiUrl}/?source=github&queryKey=MoshiCoCo`)
    // const telegramAxios = this.axios.get(`${apiUrl}/?source=telegram&queryKey=moshiyeap`)
    const bilibiliAxios = this.axios.get(`${apiUrl}/?source=bilibili&queryKey=14602398`)
    const jikeAxios = this.axios.get(`${apiUrl}/?source=jikeFollower&queryKey=2835517f-265f-4934-b502-e1023ffc70ad`)
    const steamGamesAxios = this.axios.get(`${apiUrl}/?source=steamGames&queryKey=76561198402634316`)

    // this.all([githubAxios, bilibiliAxios]).then(
    //   this.axios.spread((...resp) => {
    //     this.github = { data: resp[0].data.data.totalSubs, loading: true }
    //     // this.bilibili = { data: resp[1].data.data.totalSubs, loading: true }
    //   }),
    // ).catch(err => {
    //   this.loading = false
    //   // eslint-disable-next-line no-console
    //   console.error(err)
    // })

    githubAxios.then((r) => {
      this.github = { data: r.data.data.totalSubs, loading: false }
    })

    jikeAxios.then((r) => {
      this.jike = { data: r.data.data.totalSubs, loading: false }
    })

    steamGamesAxios.then((r) => {
      this.steam = { data: r.data.data.totalSubs, loading: false }
    })

    bilibiliAxios.then((r) => {
      this.bilibili = { data: r.data.data.totalSubs, loading: false }
    })
  },
}
</script>

<style lang='css' scoped>
.col-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: center;
}

.row-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
  align-content: stretch;
  margin: 15px 0px;
}

.row-container .statCard:last-child {
  margin-left: 30px;
}

.row-container .statCard {
  flex: 1;
}

@media screen and (max-width: 760px) {
  .row-container {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
    align-content: center;
  }

  .row-container .statCard:last-child {
    margin-left: 0px;
    margin-top: 30px;
  }
}

#substats-footer {
  color: #666666;
  text-align: left;
}
</style>
